module.exports = __webpack_public_path__ + "img/messages.855eae63.svg";